"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetryProxy = void 0;
const retryError_1 = require("./retryError");
const guard_1 = require("../utils/guard");
const utils_1 = require("./utils");
/**
 * A resiliency proxy that tries a function n times before failing with a retry error.
 */
class RetryProxy {
    /**
     * Initializes a new instance of the @see RetryProxy class.
     * @param retries Number of retries to execute.
     * @param logger Logger to use.
     */
    constructor(retries, logger) {
        guard_1.Guard.throwIfNullOrEmpty(retries, 'retries');
        guard_1.Guard.throwIfNullOrEmpty(logger, 'logger');
        this.retries = retries;
        this.logger = logger;
    }
    /**
     * Executes a function within a resilience proxy.
     * @param func Function to execute within the resilience proxy.
     * @param requestId Request Guid.
     */
    execute(func, requestId) {
        return __awaiter(this, void 0, void 0, function* () {
            let innerError;
            for (let i = 0; i < this.retries; i++) {
                try {
                    this.logger.trace(requestId, `Starting Retry ${i}/${this.retries}`, null, utils_1.logFormatter);
                    const result = yield func();
                    this.logger.trace(requestId, `Retry ${i}/${this.retries} successful`, null, utils_1.logFormatter);
                    return result;
                }
                catch (error) {
                    this.logger.warning(requestId, `Retry ${i}/${this.retries} failed`, error, utils_1.logFormatter);
                    innerError = error;
                }
            }
            const errorMessage = `Retries exceeded after ${this.retries} times`;
            this.logger.error(requestId, errorMessage, innerError, utils_1.logFormatter);
            throw new retryError_1.RetryError(errorMessage, innerError);
        });
    }
}
exports.RetryProxy = RetryProxy;
//# sourceMappingURL=retryProxy.js.map